/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UnlinkedRevokeRequest { 
    kind?: UnlinkedRevokeRequest.KindEnum;
    id?: string;
}
export namespace UnlinkedRevokeRequest {
    export type KindEnum = 'SHARE' | 'RULESET';
    export const KindEnum = {
        SHARE: 'SHARE' as KindEnum,
        RULESET: 'RULESET' as KindEnum
    };
}